import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { customBreakPointsProvider } from "app/layout/custom-breakpoints";
import { VerticalLayoutModule } from "app/layout/vertical/vertical-layout.module";
import { HorizontalLayoutModule } from "app/layout/horizontal/horizontal-layout.module";
import { TranslateModule } from "@ngx-translate/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CoreCardModule } from "../../@core/components/core-card/core-card.module";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { NgbDateParserFormatter, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CoreCommonModule } from "../../@core/common.module";
import { OnboardingHeaderComponent } from "./components/onboarding-header/onboarding-header.component";
import { SummaryAbsencesComponent } from "./components/widgets/summary-absences/summary-absences.component";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgSelectModule } from "@ng-select/ng-select";
import { PopupHolidaysComponent } from "./components/widgets/summary-absences/popup-holidays/popup-holidays.component";
import { PopupPermissionsComponent } from "./components/widgets/summary-absences/popup-permissions/popup-permissions.component";
import { PopupSicknessComponent } from "./components/widgets/summary-absences/popup-sickness/popup-sickness.component";
import { ChartsModule } from "ng2-charts";
import { StaffAddAbsenceComponent } from "./components/widgets/summary-absences/staff-add-absence/staff-add-absence.component";
import { MyTicketsComponent } from "../modules/ticket/components/my-tickets/my-tickets.component";
import { MyAssetsComponent } from "../modules/assets/components/my-assets/my-assets.component";
import { SupportRequestAssignedToMeComponent } from "../modules/ticket/components/support-request-assigned-to-me/support-request-assigned-to-me.component";
import { WidgetFutureEmployeesComponent } from "./components/widgets/widget-future-employees/widget-future-employees.component";
import { WidgetLastCandidateComponent } from "./components/widgets/widget-last-candidate/widget-last-candidate.component";
import { WidgetLastBargainingComponent } from "./components/widgets/widget-last-bargaining/widget-last-bargaining.component";
import { MyRefundsComponent } from "./components/widgets/my-refunds/my-refunds.component";
import { LastRequestsComponent } from "./components/widgets/last-requests/last-requests.component";
import { LastProposedCandidateComponent } from "./components/widgets/last-proposed-candidate/last-proposed-candidate.component";
import { ReportUnlockStatusComponent } from "./components/widgets/report-unlock-status/report-unlock-status.component";
import { TutorialVideoComponent } from "./components/modals/tutorial-video/tutorial-video.component";
import { ResignedFutureEmployeesComponent } from "./components/widgets/resigned-future-employees/resigned-future-employees.component";
import { AbsencesToWorkComponent } from "./components/widgets/absences-to-work/absences-to-work.component";
import { MyDocumentsComponent } from "./components/widgets/my-documents/my-documents.component";
import { UserFormContractComponent } from "./components/user/form/user-form-contract/user-form-contract.component";
import { AngularFileUploaderModule } from "angular-file-uploader";
import { DatepickrComponent, NgbDateMomentParserFormatter } from "./components/datepickr/datepickr.component";
import { ExportExcelComponent } from "./components/modals/export-excel/export-excel.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { SelectTableLimitComponent } from "../../@core/components/select-table-limit.component";
import { CostStandbyComponent } from "./components/widgets/cost-standby/cost-standby.component";
import { SimulationCostsComponent } from "./components/widgets/simulation-costs/simulation-costs.component";
import { RequestRefundModalComponent } from './components/modals/request-refund-modal/request-refund-modal.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';

@NgModule({
  imports: [
    FlexLayoutModule.withConfig({ disableDefaultBps: true }),
    CommonModule,
    VerticalLayoutModule,
    HorizontalLayoutModule,
    TranslateModule,
    NgxDatatableModule,
    CoreCardModule,
    BrowserModule,
    DragDropModule,
    NgbModule,
    CoreCommonModule,
    RouterModule,
    Ng2FlatpickrModule,
    NgSelectModule,
    ChartsModule,
    AngularFileUploaderModule,
  ],
  providers: [
    customBreakPointsProvider,
    {
      provide: NgbDateParserFormatter,
      useFactory: () => {
        return new NgbDateMomentParserFormatter("DD-MM-YYYY");
      },
    },
  ],
  exports: [
    VerticalLayoutModule,
    HorizontalLayoutModule,
    OnboardingHeaderComponent,
    SummaryAbsencesComponent,
    PopupHolidaysComponent,
    PopupPermissionsComponent,
    PopupSicknessComponent,
    StaffAddAbsenceComponent,
    MyTicketsComponent,
    MyAssetsComponent,
    SupportRequestAssignedToMeComponent,
    WidgetFutureEmployeesComponent,
    WidgetLastCandidateComponent,
    WidgetLastBargainingComponent,
    MyRefundsComponent,
    LastRequestsComponent,
    LastProposedCandidateComponent,
    ReportUnlockStatusComponent,
    TutorialVideoComponent,
    ExportExcelComponent,
    ResignedFutureEmployeesComponent,
    CostStandbyComponent,
    SimulationCostsComponent,
    AbsencesToWorkComponent,
    MyDocumentsComponent,
    UserFormContractComponent,
    DatepickrComponent,
    SelectTableLimitComponent,
    RequestRefundModalComponent,
    LoaderComponent,
    PdfViewerComponent,
  ],
  declarations: [
    OnboardingHeaderComponent,
    SummaryAbsencesComponent,
    PopupHolidaysComponent,
    PopupPermissionsComponent,
    PopupSicknessComponent,
    StaffAddAbsenceComponent,
    MyTicketsComponent,
    MyAssetsComponent,
    SupportRequestAssignedToMeComponent,
    WidgetFutureEmployeesComponent,
    WidgetLastCandidateComponent,
    WidgetLastBargainingComponent,
    MyRefundsComponent,
    LastRequestsComponent,
    LastProposedCandidateComponent,
    ReportUnlockStatusComponent,
    TutorialVideoComponent,
    ExportExcelComponent,
    ResignedFutureEmployeesComponent,
    AbsencesToWorkComponent,
    MyDocumentsComponent,
    UserFormContractComponent,
    DatepickrComponent,
    SelectTableLimitComponent,
    CostStandbyComponent,
    SimulationCostsComponent,
    RequestRefundModalComponent,
    LoaderComponent,
    PdfViewerComponent,
  ],
})
export class LayoutModule {}
